/** Strings for the frame components (C4): Breadcrumbs and CodeBlock. */
export const frameCopy = {
  breadcrumbs: {
    label: 'Breadcrumb',
    separator: '/',
    showHidden: 'Show hidden crumbs',
  },
  codeBlock: {
    copy: 'Copy',
    copied: 'Copied',
    captionJoiner: ' · ',
    copyName: (what: string) => `Copy ${what}`,
    copiedName: (what: string) => `Copied ${what}`,
  },
} as const
